import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import { Header,
    Form,
    Button,
    Segment,
    Icon,
    Radio,
    Divider,
    List,
    Dropdown } from 'semantic-ui-react';
import { api } from '../../../services/api';
import { isAdmin } from "../../../services/auth";

import Navbarr from '../../../components/Navbar';

import './styles.css';

const roleOptions = [
    { key: 'ROLE_ADMIN', value: 'ROLE_ADMIN', text: 'Administrador'},
    { key: 'ROLE_USUARIO', value: 'ROLE_USUARIO', text: 'Promotor'}
]

const roleDict = {
    'ROLE_ADMIN': 'Administrador',
    'ROLE_USUARIO': 'Promotor'
}

//const userMaster = "administrador";

export default function UserEdit ({ sidebar: Sidebar, ...rest}) {
    const { userEmail } = rest['location']['state'] ? rest['location']['state'] : {userEmail: null};
    const [userStates, setUserStates] = useState({
        user: {},
        formUser: {
            email: '',
            nome: '',
            senha: null,
            role: '',
            rotas: [],
            status: ''
        },
        routes: [],
        routesOptions: [],
        currentRoutes: [],
        isLoadingData: true,
        isEditing: false
    });

    const DIAS_SEMANA = ["Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];

    async function handleRoute() {
        await handleRoutes();
    }

    async function handleRoutes() {
        const currentRoutes = [];
        const routesOptions = [];
        const routes = await fetchRoutes();
        routes.forEach(
            rt => {
                routesOptions.push({key: rt['id'],
                                    text: rt['nome'],
                                    value: rt['id']});
            }
        );

        userStates['user']['rotas'].forEach(
            rt => {
                currentRoutes.push(rt['id'] !== undefined ?  rt['id'] :  null);
            }
        );

        handleRouteChange(currentRoutes);

        setUserStates(state => ({
            ...state,
            routes: routes,
            routesOptions: routesOptions,
        }));
    }

    const handleRouteChange = (value, dia=null) => {
        if (dia !== null) {
            let newCurrentRoutes = userStates['currentRoutes'];
            newCurrentRoutes[dia] = value !== "" ? value : null;
            setUserStates((prevState) => ({
                ...prevState,
                currentRoutes: newCurrentRoutes
            }));
        } else {
            setUserStates((prevState) => ({
                ...prevState,
                currentRoutes: value !== "" ? value : null
            }));
        }
    }

    const handleStatus = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                status: value
            }
        }));
    }

    const handleEmailChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                email: value
            }
        }));
    }

    const handleNomeChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                nome: value
            }
        }));
    }

    const handleRoleChange = (e, {value}) => {
        setUserStates( state => ({
            ...state,
            formUser: {
                ...state['formUser'],
                role: value
            }
        }));
    }

    async function editUser (value) {
        setUserStates(state => ({
            ...state,
            isEditing: value
        }));

        await handleRoute();
    }

    const cancelUserEdit = () => {
        setUserStates( state => ({
            ...state,
            formUser: state['user'],
            isEditing: false
            }
        ));
    }

    async function handlePut() {
        try {

            setUserStates( state => ({
                ...state,
                isLoading: true,
            }));

            const rotas = [];
            const lojas = [];

            userStates['currentRoutes'].forEach(
                rt => rotas.push(rt !== null ? {'id':rt} : null)
            );

            userStates['user']['lojas'].forEach(
                loja => lojas.push({'id':loja['id']})
            );

            const data = await api.putUser(userStates['formUser']['email'],
                                            userStates['formUser']['nome'],
                                            userStates['formUser']['senha'],
                                            userStates['formUser']['role'],
                                            userStates['formUser']['status'],
                                            rotas, lojas);
            Alert.success('Usuário atualizado com sucesso!');
            setUserStates( state => ({
                ...state,
                user: data,
                formUser: {
                    ...state['formUser'],
                    ...data
                },
                isLoadingData: false,
                isEditing: false
            }));
        } catch (err) {
            Alert.error('Falha ao atualizar usuário.');
            console.error('Falha ao atualizar usuário: ', err);
            setUserStates( state => ({
                ...state,
                isLoadingData: false,
                isEditing: true
            }));
        }
    }

    async function fetchRoutes() {
        try {
            const data = await api.getRoutes();
            return data;
        } catch (err) {
            console.error("Falha ao obter rotas: ", err);
        }
    }

    useEffect(() => {
        async function fetchUser() {
            try {
                const data = await api.getUserId(userEmail);
                setUserStates( state => ({
                    ...state,
                    user: data,
                    formUser: {
                        ...state['formUser'],
                        ...data
                    },
                    isLoadingData: false
                }));
            } catch (err) {
                console.error("Falha ao obter usuário: ", err);
            }
        }
        if (isAdmin() && userEmail) fetchUser();
    },[userEmail]);

    if (isAdmin()) {
        return (
            <Container className="u-content">
                <Side style={{flex: '0 0 auto', width: 'auto'}}>
                    <Sidebar page={"userlist"}></Sidebar>
                </Side>
                <Container>
                    <HeaderRS>
                        <Navbarr></Navbarr>
                    </HeaderRS>
                    <Content style={{backgroundColor: '#FAFAFA', padding: '5px'}}>
                        <div>
                            <Segment
                                loading={userStates['formUser'] ? false : true}
                                style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                                >
                                <Header as='h3' floated='left'>
                                    Informações do Usuário
                                </Header>
                                {!userStates['isEditing'] && <Button
                                    primary
                                    size="mini"
                                    floated='right'
                                    onClick={() => editUser(true)}>
                                        <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                            <Icon name='edit'/> Editar
                                        </div>
                                </Button>}

                                <Divider clearing />
                                <Form>
                                    <Form.Group inline>
                                        <label>Status</label>
                                        <Form.Field
                                            readOnly={!userStates['isEditing']}
                                            control={Radio}
                                            label='Ativo'
                                            value='ATIVO'
                                            checked={userStates['formUser'] && userStates['formUser']['status'] === 'ATIVO' ? true : false}
                                            onChange={handleStatus}
                                        />
                                        <Form.Field
                                            readOnly={!userStates['isEditing']}
                                            control={Radio}
                                            label='Inativo'
                                            value='INATIVO'
                                            checked={userStates['formUser'] && userStates['formUser']['status'] === 'INATIVO' ? true : false}
                                            onChange={handleStatus}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='mail'
                                            fluid label='Email'
                                            placeholder='Email'
                                            value={userStates['formUser'] ? userStates['formUser']['email']: ""}
                                            onChange={handleEmailChange}
                                            />
                                        <Form.Input
                                            readOnly={!userStates['isEditing']}
                                            iconPosition='left'
                                            icon='user'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={userStates['formUser'] ? userStates['formUser']['nome']: ""}
                                            onChange={handleNomeChange}
                                            />
                                        {!userStates['isEditing'] && <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='male'
                                            fluid label='Papel'
                                            placeholder={userStates['formUser'] ? roleDict[userStates['formUser']['role']] : ""}
                                            //value={userStates['formUser'] ? roleDict[userStates['formUser']['role']] : ""}
                                            /> }
                                        { userStates['isEditing'] && <Form.Select
                                            fluid label='Papel'
                                            options={roleOptions}
                                            value={userStates['formUser'] ? userStates['formUser']['role'] : ""}
                                            placeholder='Status'
                                            onChange={handleRoleChange}
                                            /> }
                                    </Form.Group>
                                        {userStates['formUser'] && userStates['formUser']['role'] === 'ROLE_USUARIO'
                                            &&
                                            <Header as='h4' dividing>
                                                <Header.Content>
                                                    Rotas
                                                </Header.Content>
                                            </Header>
                                        }
                                        {userStates['formUser'] && !userStates['isEditing'] && userStates['formUser']['role'] === 'ROLE_USUARIO'
                                            &&
                                            <List divided relaxed style={{marginTop: '30px'}}>
                                            {userStates['formUser']['rotas'].slice(1,7).map((rota, index) => {
                                                return (
                                                    <List.Item key={rota['id']}>
                                                        <List.Content>
                                                            <List.Header style={{fontSize: '13px'}}>
                                                                {DIAS_SEMANA[index]}
                                                            </List.Header>
                                                            <List.Description style={{fontSize: '12px'}}>Rota: {rota['nome']}</List.Description>
                                                            <List.Description style={{fontSize: '12px'}}>Id: {rota['id']}</List.Description>
                                                        </List.Content>
                                                    </List.Item>)
                                                })
                                            }
                                        </List> }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Segunda-Feira</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de segunda'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][1]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 1)}
                                                />
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Terça-Feira</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de terça'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][2]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 2)}
                                                />
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Quarta-Feira</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de quarta'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][3]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 3)}
                                                />
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Quinta-Feira</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de quinta'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][4]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 4)}
                                                />
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Sexta-Feira</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de quinta'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][5]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 5)}
                                                />
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Sábado</label>
                                            </Form.Group>
                                        }

                                        {userStates['formUser'] && userStates['isEditing'] &&
                                            <Form.Group inline>
                                                <Dropdown
                                                    disabled={!userStates['isEditing']}
                                                    options={userStates['routesOptions']}
                                                    placeholder='Escolha a rota de sábado'
                                                    search
                                                    selection
                                                    fluid
                                                    clearable
                                                    value={userStates['currentRoutes'][6]}
                                                    onChange={(e,{value}) => handleRouteChange(value, 6)}
                                                />
                                            </Form.Group>
                                        }

                                        <Form.Group>
                                        {userStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            type='submit'
                                            size="mini"
                                            floated='right'
                                            onClick={handlePut}>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>}
                                        {userStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            color='red'
                                            size="mini"
                                            floated='right'
                                            onClick={cancelUserEdit}>
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='cancel'/> Cancelar
                                                </div>
                                        </Button>}
                                        </Form.Group>
                                    </Form>
                            </Segment>
                        </div>
                    </Content>
                    <Footer></Footer>
                </Container>
            </Container>
        );
    } else {
        return (
            <Redirect to="/dashboard" />
        )
    }
}
